/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Permissions_UpdatedInputs */

const en_admin_permissions_updated = /** @type {(inputs: Admin_Permissions_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Permission updated`)
};

/**
* | output |
* | --- |
* | "Permission updated" |
*
* @param {Admin_Permissions_UpdatedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_permissions_updated = /** @type {((inputs?: Admin_Permissions_UpdatedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Permissions_UpdatedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_permissions_updated(inputs)
});
export { admin_permissions_updated as "admin.permissions.updated" }